module.exports = __webpack_public_path__ + "img/3x.28fc1cc.jpg";